import React from 'react';
import {
  IconSize,
  type Props as IconWrapProps,
} from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './OrdersSectionTitle.scss';

interface Props {
  title: string;
  icon: React.ComponentType<IconWrapProps>;
}

const OrdersSectionTitle: React.FC<Props> = ({ title, icon: Icon }) => {
  return (
    <div className={s['root']}>
      <Icon className={s['icon']} size={IconSize.SMALL} disableDefaultColors />
      <span>{title}</span>
    </div>
  );
};

export default OrdersSectionTitle;
